import React from 'react';
import './info.sass';
import { infoMap } from '../../../const';

export const InfoMapMap = ( ) => {
        return(
            <>
                {infoMap.map((item:{imgsrc: string, imgalt: string, divTextInfo: string}, index: number) => {
                    return(
                        <div  key={index} className="Info_about_me_all adaptivnost_otstupov">
                            <img src={ item.imgsrc } alt={ item.imgalt } id="img_info" />
                            <p key={index} className="infoMapText">{ item.divTextInfo }</p>
                        </div>
                    )
                }
                )}
            </>
        )
    }